import {
  type DownloadComplete,
  DownloadStatus,
} from '../../types/isomorphic/downloadRequest.types';

const hasStatusProperty = (obj: unknown): obj is { status: unknown } =>
  typeof obj === 'object' && obj !== null && 'status' in obj;

const isCompleteDownloadRequest = (
  request: unknown
): request is DownloadComplete =>
  hasStatusProperty(request) && request.status === DownloadStatus.DOWNLOADED;

export default isCompleteDownloadRequest;
